import { Injectable } from '@angular/core';
import {
  CURRENT_POLICY,
  USER_ID,
  CURRENT_POLICY_LOB,
  CURRENT_POLICY_STATE,
  CURRENT_POLICY_STATUS,
  CURRENT_POLICY_PRODUCT_CODE
} from '@prcins/constants';

declare const sm: any;

@Injectable({
  providedIn: 'root'
})
export class GliaService {

  /**
   * Called after login — pushes authenticated visitor context into Glia so
   * the custom engine webhook receives it in visitor_attributes.
   */
  updateVisitorContext(): void {
    if (typeof sm === 'undefined') {
      return; // Glia script not loaded yet
    }

    const policyNumber = sessionStorage.getItem(CURRENT_POLICY) || '';
    const userId = sessionStorage.getItem(USER_ID) || '';
    const lob = sessionStorage.getItem(CURRENT_POLICY_LOB) || '';
    const state = sessionStorage.getItem(CURRENT_POLICY_STATE) || '';
    const policyStatus = sessionStorage.getItem(CURRENT_POLICY_STATUS) || '';
    const productCode = sessionStorage.getItem(CURRENT_POLICY_PRODUCT_CODE) || '';

    sm.getApi({ version: 'v1' }).then((glia: any) => {
      glia.updateInformation({
        customAttributesUpdateMethod: 'merge',
        customAttributes: {
          policy_number: policyNumber,
          customer_number: userId,
          lob,
          state,
          policy_status: policyStatus,
          product_code: productCode,
          authenticated: 'true'
        }
      }).catch((error: any) => {
        console.warn('[Glia] updateInformation error:', error);
      });
    }).catch((error: any) => {
      console.warn('[Glia] getApi error:', error);
    });
  }

  /**
   * Called on logout — clears visitor context from Glia.
   */
  clearVisitorContext(): void {
    if (typeof sm === 'undefined') {
      return;
    }

    sm.getApi({ version: 'v1' }).then((glia: any) => {
      glia.updateInformation({
        customAttributes: {
          policy_number: '',
          customer_number: '',
          authenticated: 'false'
        }
      }).catch((error: any) => {
        console.warn('[Glia] clearVisitorContext error:', error);
      });
    });
  }
}
